import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';

const SignIn: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Пожалуйста, заполните все поля');
      return;
    }

    try {
      setError(null);
      setIsLoading(true);
      const result = await login(email, password);
      
      if (result.error) {
        setError(result.error);
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError('Произошла ошибка при входе. Попробуйте позже.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <motion.div 
          className="auth-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="auth-header">
            <h2 className="auth-title pencil-text">Вход в аккаунт</h2>
            <p className="auth-subtitle pencil-text">
              Добро пожаловать обратно! Войдите, чтобы продолжить обучение.
            </p>
          </div>

          {error && (
            <div className="auth-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email" className="pencil-text">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="auth-input"
                placeholder="example@mail.ru"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="pencil-text">Пароль</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="auth-input"
                placeholder="Ваш пароль"
                required
              />
            </div>

            <button 
              type="submit" 
              className="auth-button pencil-outline"
              disabled={isLoading}
            >
              {isLoading ? 'Вход...' : 'Войти'}
            </button>
          </form>

          <div className="auth-links">
            <p className="pencil-text">
              Еще нет аккаунта? <Link to="/signup" className="auth-link">Зарегистрироваться</Link>
            </p>
            <p className="pencil-text">
              <Link to="/" className="auth-link">Вернуться на главную</Link>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SignIn; 